import React, { PropTypes } from "react"
import { connect } from "react-redux"
import AlertModal from "./AlertModal"
import ConfirmRemoveModal from "./ConfirmRemoveModal"
import InvitedAddedMembersModal from "./InvitedAddedMembersModal"
import NotifyErrorModal from "./NotifyErrorModal"
import UnlockPremiumModal from "./UnlockPremiumModal"
import NextStepsModal from "./NextStepsModal"
import ClassifyFilteredModal from "./ClassifyFilteredModal"
import NameThisPlaceModal from "./NameThisPlaceModal"
import VideoModal from "./VideoModal"
import BankCardSyncModal from "./BankCardSyncModal"
import PlaidImportHistoryModal from "./PlaidImportHistoryModal"
import IntegrationsModal from "./IntegrationsModal"

// NOTE convention on how to add additional modal types:
// https://stackoverflow.com/questions/35623656/how-can-i-display-a-modal-dialog-in-redux-that-performs-asynchronous-actions/35641680
const MODAL_COMPONENTS = {
  ALERT_MODAL: AlertModal,
  CONFIRM_REMOVE_MODAL: ConfirmRemoveModal,
  INVITED_AND_ADDED_MEMBERS: InvitedAddedMembersModal,
  NOTIFY_ERROR_MODAL: NotifyErrorModal,
  UNLOCK_PREMIUM_MODAL: UnlockPremiumModal,
  NEXT_STEPS_MODAL: NextStepsModal,
  INTRO_VIDEO_MODAL: VideoModal,
  CLASSIFY_FILTERED_MODAL: ClassifyFilteredModal,
  NAME_THIS_PLACE_MODAL: NameThisPlaceModal,
  BANK_CARD_SYNC_MODAL: BankCardSyncModal,
  PLAID_IMPORT_HISTORY_MODAL: PlaidImportHistoryModal,
  INTEGRATIONS_MODAL: IntegrationsModal
  /* other modals get added here */
}

const ModalRoot = ({ modalType, modalProps }) => {
  if (!modalType) {
    return null
  }

  const SpecificModal = MODAL_COMPONENTS[modalType]
  if (!SpecificModal)
    console.warn(`${modalType} needs to be defined in ModalRoot.js`)
  return <SpecificModal {...modalProps} />
}

export default connect(state => state.modal)(ModalRoot)

// The keys of the MODAL_COMPONENTS object can be used in the prop types to catch dev-time errors.
// https://vasanthk.gitbooks.io/react-bits/patterns/30.component-switch.html
ModalRoot.propTypes = {
  modalType: PropTypes.oneOf(Object.keys(MODAL_COMPONENTS)).isRequired
}



// WEBPACK FOOTER //
// ./src/modal/ModalRoot.js